export default (initialState = {}) => {
  return () => {
    return {
      addl_bills: [],
      billing_address: "",
      buyer_name: "",
      buyer_gstin: "",
      date: new Date(),
      lineitems: [],
      number: "",
      payment_terms: "",
      po_info: {},
      remarks: "",
      shipping_address: "",
      status_cd: "active",
      total_amount: null,
      total_tax: null,
      vehicle_number: "",
      ...initialState,
    };
  };
};
